import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="nav">
      <div className="nav-inner">
        {/* SOCIAL BUTTONS */}
        <div className="nav-socials">
          <a
            href="https://www.instagram.com/tamara_whatsfordessert/?ref=badge"
            target="_blank"
            rel="noreferrer"
            className="nav-social insta"
            aria-label="Instagram"
          >
            Instagram
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=100063697717720"
            target="_blank"
            rel="noreferrer"
            className="nav-social fb"
            aria-label="Facebook"
          >
            Facebook
          </a>
        </div>

        {/* BURGER BUTTON */}
        <button
          className={`menu-toggle ${menuOpen ? "open" : ""}`}
          onClick={toggleMenu}
          aria-label={menuOpen ? "Zatvori meni" : "Otvori meni"}
          aria-expanded={menuOpen}
          type="button"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* LINKS */}
        <nav
          className={`links ${menuOpen ? "active" : ""}`}
          role="navigation"
          aria-label="Glavna navigacija"
        >
          <Link to="/" onClick={closeMenu} aria-label="Naslovna stranica">
            Naslovna
          </Link>

          <Link to="/o-meni" onClick={closeMenu} aria-label="O meni">
            O meni
          </Link>

          <Link to="/indeks" onClick={closeMenu} aria-label="Indeks recepata">
            Indeks recepata
          </Link>

          <Link to="/putovanja" onClick={closeMenu} aria-label="Putovanja">
            Putovanja
          </Link>

          <Link to="/kontakt" onClick={closeMenu} aria-label="Kontakt">
            Kontakt
          </Link>

          <Link to="/all-recipes" onClick={closeMenu} aria-label="Svi recepti">
            Tražilica recepata
          </Link>

          <Link
            to="/prijava"
            onClick={closeMenu}
            className="admin-link"
            aria-label="Admin prijava"
          >
            Admin prijava
          </Link>
        </nav>
      </div>
    </nav>
  );
}
